class AccountSettings.AttributeValidationRules extends Backbone.Model
  default:
    code: ''
    name: ''
    presence_validation: false



class AccountSettings.AttributeValidationRulesCollection extends Backbone.Collection
  model: AccountSettings.AttributeValidationRules
